"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectUtil = exports.SelectSizes = void 0;
exports.SelectSizes = {
    sm: '120px',
    md: '160px',
    lg: '200px',
    xlg: '100%',
};
// TODO: remove switch, replace with simple return
// TODO: change param size to type Size
exports.SelectUtil = {
    getSelectWidth: function (selectWidth, selectSize) {
        if (selectWidth !== 'auto') {
            return selectWidth;
        }
        if (selectSize) {
            return exports.SelectSizes[selectSize];
        }
        return selectWidth;
    },
};
